// extracted by mini-css-extract-plugin
export default {"component":"page_component__Kg2gy","title":"page_title__nkvcL"};